export default __webpack_public_path__ + "media/zurb/img/about/talent/talent-img5-00540ce6bb5a514e2d0d95e9273228f9.png";